import { appLoader } from "./utils";

//
// modal window commonly used for jokers
//

export function notificationModal($modalRequestButton, $modalWindow) {
  if (!$modalRequestButton.length || !$modalWindow.length || $modalRequestButton.hasClass('joker-modal-skip')) { return; }

  $modalRequestButton.on('click', function(e) {
    e.preventDefault();
    const $this = $(e.target);

    return $modalWindow.modal({
      closable: !$this.hasClass('joker-with-ad'),

      onShow() {
        if ($modalRequestButton.hasClass('intellitest-nav')) { $('body').addClass('mobile-nav-open'); }
      },

      onHidden() {
        if ($modalRequestButton.hasClass('intellitest-nav')) { $('body').removeClass('mobile-nav-open'); }
      },

      onApprove() {
        appLoader(true);
        location.href = $modalRequestButton.attr('href');
      }

    }).modal('show');
  });
}

export function appDownloadModal() {
  let appDownloadModal = document.querySelector('.app-download');
  if (!appDownloadModal) { return; }

  let watchDialogs = (redirectUrl, isForm = false, formNode = null) => {
    appDownloadModal.querySelectorAll('.btn-decline, .overlay').forEach((_target) => {
      _target.addEventListener('click', (_event) => {
        _event.preventDefault();
        appDownloadModal.classList.remove('active');

        if (isForm && formNode) {
          formNode.submit();
          return;
        }

        window.location.href = redirectUrl;
      });
    });

    appDownloadModal.querySelector('.btn-proceed').addEventListener('click', (_event) => {
      _event.preventDefault();
      appDownloadModal.classList.remove('active');
      window.open(_event.target.dataset.href);

      if (isForm && formNode) {
        formNode.submit();
        return;
      }

      window.location.href = redirectUrl;
    });
  }

  let answerButtons = document.querySelectorAll('.game-answers a.btn, .game-answer-input button[type=submit]');
  answerButtons.forEach((answerButton) => {
    answerButton.addEventListener('click', (event) => {
      event.preventDefault();
      appDownloadModal.classList.add('active');

      if (event.target.nodeName.toLowerCase() === 'button' && !!event.target.formAction.length) {
        watchDialogs(null, true, document.querySelector('form.game-answer-input'));
        return;
      }

      watchDialogs(event.target.href ?? event.target.parentNode.href);
    });
  });
}